// material-ui
import { useTheme } from '@mui/material/styles';
import LogoIcon from 'assets/images/icons/logo.png';
import LogoDark from 'assets/images/icons/logoDark.png';
import { useSelector } from 'react-redux';
import { THEME_LIGHT } from '../../store/reducers/menu';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    const theme = useTheme();
    const logoTheme = useSelector((state) => state.menu.theme);

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Mantis" width="100" />
         *
         */
        <>
            <img src={logoTheme === THEME_LIGHT ? LogoIcon : LogoDark} alt="Chronos" width="100%" />
        </>
    );
};

export default Logo;
